export default {
  app: {
    notFound: {
      title: 'Página no encontrada.',
      subtitle: 'Parece que te perdiste.',
      text: 'No te preocupes, te ayudaremos a navegar desde aquí',
    },
  },
};
